export default __webpack_public_path__ + "assets/Miner-2.0c93.svg";